import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { validatePassword } from 'src/services/user'
import { ModalContext, useHandler, Form } from 'labguard-cdk'
import { useMutation } from 'react-apollo'
import ChangePasswordModal from './ChangePasswordModal'

const changeUserPasswordMutation = gql`
  mutation changeUserPassword($userId: ID!, $newPassword: String!, $confirmNewPassword: String!) {
    changeUserPassword(userId: $userId, newPassword: $newPassword, confirmNewPassword: $confirmNewPassword) {
      id
    }
  }
`

const changeAccountPasswordMutation = gql`
  mutation changeAccountPassword($password: String!, $newPassword: String!, $confirmNewPassword: String!) {
    changeAccountPassword(password: $password, newPassword: $newPassword, confirmNewPassword: $confirmNewPassword) {
      id
    }
  }
`

const changeExpiredPasswordMutation = gql`
  mutation changeExpiredPassword(
    $username: String!
    $password: String!
    $newPassword: String!
    $confirmNewPassword: String!
  ) {
    changeExpiredPassword(
      username: $username
      password: $password
      newPassword: $newPassword
      confirmNewPassword: $confirmNewPassword
    ) {
      id
    }
  }
`

export default function ChangePasswordModalContainer({ user, provideUsername, providePassword }) {
  const [changeUserPassword] = useMutation(changeUserPasswordMutation)
  const [changeAccountPassword] = useMutation(changeAccountPasswordMutation)
  const [changeExpiredPassword] = useMutation(changeExpiredPasswordMutation)
  const { close } = ModalContext.use()

  const onSubmit = useHandler(({ id, username, password, newPassword, confirmNewPassword }) =>
    (provideUsername
      ? changeExpiredPassword({ variables: { username, password, newPassword, confirmNewPassword } })
      : providePassword
      ? changeAccountPassword({ variables: { password, newPassword, confirmNewPassword } })
      : changeUserPassword({ variables: { userId: id, newPassword, confirmNewPassword } })
    ).finally(close)
  )

  const validate = useHandler(values => validatePassword(values, { providePassword, provideUsername }))

  return (
    <Form initialValues={user} validate={validate} onSubmit={onSubmit}>
      <ChangePasswordModal provideUsername={provideUsername} providePassword={providePassword} />
    </Form>
  )
}

ChangePasswordModalContainer.propTypes = {
  user: PropTypes.object,
  provideUsername: PropTypes.bool,
  providePassword: PropTypes.bool,
}
